import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../../app/guards'
import { reconciliationSearchSchema } from '../../../features/projects/contracting/claims-search'
import { ReconciliationPage } from '../../../features/projects/contracting/reconciliation-page'

/** Contract reconciliation: project money and the ledger, both (as the API's route). */
export const Route = createFileRoute('/_app/projects/reconciliation')({
  staticData: { crumb: 'projectReconciliation' },
  validateSearch: reconciliationSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, ['projects.financials', 'ledger.read']),
  component: ReconciliationPage,
})
